import { useEffect, useCallback, useRef } from "react";
import { useAuth, AppRole } from "@/contexts/AuthContext";

function getInactivityTimeout(roles: AppRole[]): number {
  if (roles.includes("superadmin") || roles.includes("auditor")) return 10 * 60 * 1000; // 10 minutes
  if (roles.includes("student")) return 3 * 60 * 1000;     // 3 minutes
  return 5 * 60 * 1000;                                    // 5 minutes
}

export function useInactivityLogout() {
  const { user, roles, signOut } = useAuth();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (user) {
      timerRef.current = setTimeout(() => {
        signOut();
      }, getInactivityTimeout(roles));
    }
  }, [user, roles, signOut]);

  useEffect(() => {
    if (!user) return;

    const events = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click"];
    events.forEach((e) => window.addEventListener(e, resetTimer));
    resetTimer();

    return () => {
      events.forEach((e) => window.removeEventListener(e, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [user, resetTimer]);
}
